import React,{useRef, useState, useEffect} from "react";
import {Form, Col, Row, Spinner } from "react-bootstrap";
import { HuePicker } from 'react-color';
import ColorPicker from "../components/ColorPicker";
import vindrApi from "../utils/vindrapi";
import StyleParam from "../components/StyleParam";
import EditableRange from "../components/EditableRange";

class LayerStylePanel extends React.Component {

	
	constructor(props) {
		super(props);
		
		this.state = {
			layer: null,
			fillByParam: false,
			lineByParam: false,
			layerParams: false,
			circleByParam: false,
			outlineByParam: false,
			
		}
		this.fillHue = React.createRef();
		this.optionsPanel = React.createRef();
		
		this.layerProp = this.props.layer.data.layer
		this.outlineLayer = null;
		
		this.layerObj = Array.isArray(this.layerProp) ? this.layerProp[0] : this.layerProp;
		
		if(this.layerObj.type == "fill"){
			this.outlineLayer = {
				paint: {
					'fill-outline-color' : '#000000',
					'fill-outline-width' : 0
				}
			}
			if(Array.isArray(this.layerProp)){
				var outlineLayerIdx = this.layerProp.findIndex((o)=>{return this.layerObj.id+'_outline' == o.id});
				
				if(outlineLayerIdx != -1)
					this.outlineLayer = this.layerProp[outlineLayerIdx];
			}
		}
	}
	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	setOpacity(value){
		this.setState({opacity:value});
		this.forceUpdate();
	}
	setLayer(l){
		

		
		this.setState({layer:l});
	}
	handleClose(e){
		if(this.props.onClose)
			this.props.onClose(e);
	}
	handleOpacityChange = (opc) => {

		var opacity = parseFloat(opc);
		
		if(this.props.onOpacityChange)
			this.props.onOpacityChange(opacity);
		
	};

	handlePaintChange(prop, code){
		if(this.props.onPaintChange)
			this.props.onPaintChange(prop, code);
	}
	componentDidMount() {
			
			if(!this.layerObj.paint)
				this.layerObj.paint = {};
		
			this.updateStatus({
				fillByParam:this.layerObj.paint["fill-color"] && Array.isArray(this.layerObj.paint["fill-color"]),
				lineByParam:this.layerObj.paint["line-color"] && Array.isArray(this.layerObj.paint["line-color"]),
				circleByParam:this.layerObj.paint["circle-color"] && Array.isArray(this.layerObj.paint["circle-color"]),
				outlineByParam:this.outlineLayer ? this.outlineLayer.paint["line-color"] && Array.isArray(this.outlineLayer.paint["line-color"]) : false,
			});
		if(!this.state.layerParams)
			vindrApi.getLayerProperties(this.layerObj['source-layer']).then((r)=>{
				this.updateStatus({
					layerParams: r.fields,
				});
			});
		
		
	}
	
	render() {
		
		var layerProp = this.props.layer.data.layer
		
		var layerObj = Array.isArray(layerProp) ? layerProp[0] : layerProp;
		
		if(layerObj.type == "fill"){
			var outlineLayer = {
				paint: {
					'fill-outline-color' : '#000000',
					'fill-outline-width' : 0
				}
			}
			if(Array.isArray(layerProp)){
				var outlineLayerIdx = layerProp.findIndex((o)=>{return layerObj.id+'_outline' == o.id});
				
				if(outlineLayerIdx != -1)
					outlineLayer = layerProp[outlineLayerIdx];
			}
			
		}
		
		return ( !!this.props.layer && 
			
			<div className="opacity-panel" ref={this.optionsPanel} >
				<Row>
					<Col xs="12 title pb-3 mb-3">
						<b title={this.props.layer.text}>{this.props.layer.text}</b> <i onClick={(e)=>{this.handleClose(e);}} className="ri-close-large-fill"></i>
					</Col>
				</Row>
				<Row>
					<Col xs="12 style-name">
						Layer opacity
					</Col>
					<Col xs="12 pt-2">
						<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={typeof this.props.layer.data.opacity != 'undefined' ? this.props.layer.data.opacity*100 : 100} defaultValue={this.props.layer.data.opacity*100} onChange={(e)=>{this.handleOpacityChange(e.target.value/100);}} />
					</Col>
				</Row>
				{ (layerObj.type != 'raster') && 
					<Row>
						{layerObj.type == 'line' &&
							<>
								<Col xs="12" className="style-options">
									Line color

									<div>

										<i title="Solid color" className={"ri-paint-line "+(this.state.lineByParam ? "" : "active")} onClick={(e)=>{this.updateStatus({lineByParam:false}); this.handlePaintChange('line-color', "#000000")}}></i>

										<i title="Color by parameter" className={"ri-equalizer-line "+(this.state.lineByParam ? "active" : "")} onClick={(e)=>this.updateStatus({lineByParam:true})}></i>
									</div>
								</Col>
								{!this.state.lineByParam &&
									<div className="mb-3">
										<Col xs="12">
											<ColorPicker onChange={(hex)=>{this.handlePaintChange('line-color', hex)}} color={layerObj.paint['line-color']} />
										</Col>
									</div>
								}
								{this.state.lineByParam && this.state.layerParams &&
									<div className="mb-3">
										<Col xs="12">
											<StyleParam color={layerObj.paint['line-color']} onChange={(rules)=>{this.handlePaintChange('line-color', rules);}} params={this.state.layerParams} />
										</Col>
									</div>
								}
								{this.state.lineByParam && !this.state.layerParams &&
									<div className="mb-3">
										<Spinner animation="border" variant="success" />
									</div>
								}
								<div className="my-1" >
									<Col xs="12">
										Line width
									</Col>
									<Col xs="12">
										<EditableRange wrpClassName="mb-3"  min="1" max="5" step="1" value={layerObj.paint['line-width']} onChange={(e)=>{this.handlePaintChange('line-width', parseFloat(e.target.value));}} />
									</Col>
								</div>
								{/*
								<div className="my-1" >
									<Col xs="12">
										Line style
									</Col>
									<Col xs="12 line-style-options">

										<i title="Solid color" className={"solid "+(!layerObj.paint['line-dasharray'] ? 'active' : '')} onClick={(e)=>this.handlePaintChange('line-dasharray', null)}></i>

										<i title="Color by parameter" className={"dashed "+(Array.isArray(layerObj.paint['line-dasharray']) && layerObj.paint['line-dasharray'][0] == 2 ? 'active' : '')} onClick={(e)=>this.handlePaintChange('line-dasharray', [2,2])}></i>

										<i title="Color by parameter" className={"dotted "+(Array.isArray(layerObj.paint['line-dasharray']) && layerObj.paint['line-dasharray'][0] == .5  ? 'active' : '')} onClick={(e)=>this.handlePaintChange('line-dasharray', [.5,.5])}></i>
									</Col>
								</div>
									*/}
							</>
						}
						{layerObj.type == 'circle' &&
							<>
								<Col xs="12" className="style-options">
									Circle color

									<div>

										<i title="Solid color" className={"ri-paint-line "+(this.state.circleByParam ? "" : "active")} onClick={(e)=>{this.updateStatus({circleByParam:false}); this.handlePaintChange('circle-color', "#000000")}}></i>

										<i title="Color by parameter" className={"ri-equalizer-line "+(this.state.circleByParam ? "active" : "")} onClick={(e)=>this.updateStatus({circleByParam:true})}></i>
									</div>
								</Col>
								{!this.state.circleByParam &&
									<div className="mb-3">
										<Col xs="12">
											<ColorPicker onChange={(hex)=>{this.handlePaintChange('circle-color', hex)}} color={layerObj.paint['circle-color']} />
										</Col>
									</div>
								}
								{this.state.circleByParam && this.state.layerParams &&
									<div className="mb-3">
										<Col xs="12">
											<StyleParam color={layerObj.paint['circle-color']} onChange={(rules)=>{this.handlePaintChange('circle-color', rules)}} params={this.state.layerParams} />
										</Col>
									</div>
								}
								{this.state.circleByParam && !this.state.layerParams &&
									<div className="mb-3">
										<Spinner animation="border" variant="success" />
									</div>
								}
								<div className="my-1">
									<Col xs="12 style-name">
										Radius
									</Col>
									<Col xs="12">
										<EditableRange wrpClassName="mb-3" min="2" max="50" step="1" value={layerObj.paint['circle-radius']} onChange={(e)=>{this.handlePaintChange('circle-radius', parseFloat(e.target.value));}} />
									</Col>
								</div>
								<div className="my-1">
									<Col xs="12 style-name">
										Blur
									</Col>
									<Col xs="12">
										<EditableRange wrpClassName="mb-3" min="0" max="1" step=".01" value={layerObj.paint['circle-blur']} onChange={(e)=>{this.handlePaintChange('circle-blur', parseFloat(e.target.value));}} />
									</Col>
								</div>
								<div className="my-1">
									<Col xs="12 style-name">
										Line width
									</Col>
									<Col xs="12">
										<EditableRange wrpClassName="mb-3" min="0" max="10" step="1" value={layerObj.paint['circle-stroke-width'] ? layerObj.paint['circle-stroke-width'] : 0} onChange={(e)=>{this.handlePaintChange('circle-stroke-width', parseFloat(e.target.value));}} />
									</Col>
								</div>
							</>
						}
						{layerObj.type == 'fill' &&
							<>
								<Col xs="12" className="style-options">
									Fill color

									<div>

										<i title="Solid fill" className={"ri-paint-line "+(this.state.fillByParam ? "" : "active")} onClick={(e)=>{this.updateStatus({fillByParam:false}); this.handlePaintChange('fill-color', "#000000")}}></i>

										<i title="Color by parameter" className={"ri-equalizer-line "+(this.state.fillByParam ? "active" : "")} onClick={(e)=>this.updateStatus({fillByParam:true})}></i>
									</div>

								</Col>
								{!this.state.fillByParam &&
									<div className="mb-3">
										<Col xs="12">
										
											<ColorPicker ref={this.fillHue} onChange={(hex)=>{this.handlePaintChange('fill-color', hex)}} color={layerObj.paint['fill-color']} />
										</Col>
									</div>
								}
								{this.state.fillByParam && this.state.layerParams &&
									<div className="mb-3">
										<Col xs="12">
											<StyleParam color={layerObj.paint['fill-color']} onChange={(rules)=>{this.handlePaintChange('fill-color', rules);}} params={this.state.layerParams} />
										</Col>
									</div>
								}
								{this.state.fillByParam && !this.state.layerParams &&
									<div className="mb-3">
										<Spinner animation="border" variant="success" />
									</div>
								}
								<div className="my-1" >
									<Col xs="12 style-name">
										Stroke width
									</Col>
									<Col xs="12">
										<EditableRange wrpClassName="mb-3" min="0" max="5" step=".5" value={outlineLayer.paint['line-width'] ? outlineLayer.paint['line-width'] : 0} onChange={(e)=>{this.handlePaintChange('fill-outline-width', parseFloat(e.target.value));}} />
									</Col>
								</div>
								<Col xs="12" className="style-options">
									Stroke color

									<div>

										<i title="Solid outline" className={"ri-paint-line "+(this.state.outlineByParam ? "" : "active")} onClick={(e)=>{this.updateStatus({outlineByParam:false}); this.handlePaintChange('fill-outline-color', "#000000")}}></i>

										<i title="Color by parameter" className={"ri-equalizer-line "+(this.state.outlineByParam ? "active" : "")} onClick={(e)=>this.updateStatus({outlineByParam:true})}></i>
									</div>

								</Col>

								{!this.state.outlineByParam &&
									<div className="mb-3">
										<Col xs="12">
											<ColorPicker onChange={(hex)=>{this.handlePaintChange('fill-outline-color', hex)}} color={outlineLayer.paint['line-color']} />
										</Col>
									</div>
								}
								
								{this.state.outlineByParam && this.state.layerParams &&
									<div className="mb-3">
										<Col xs="12">
											<StyleParam color={outlineLayer.paint['line-color']} onChange={(rules)=>{this.handlePaintChange('fill-outline-color', rules);}} params={this.state.layerParams} />
										</Col>
									</div>
								}
								{this.state.outlineByParam && !this.state.layerParams &&
									<div className="mb-3">
										<Spinner animation="border" variant="success" />
									</div>
								}
								{/*
								<div className="my-1" >
									<Col xs="12 style-name">
										Line style
									</Col>
									<Col xs="12 line-style-options">

										<i title="Solid color" className={"solid "+(!outlineLayer.paint['line-dasharray'] ? 'active' : '')} onClick={(e)=>this.handlePaintChange('fill-outline-dasharray', null)}></i>

										<i title="Color by parameter" className={"dashed "+(Array.isArray(outlineLayer.paint['line-dasharray']) && outlineLayer.paint['line-dasharray'][0] == 2 ? 'active' : '')} onClick={(e)=>this.handlePaintChange('fill-outline-dasharray', [2,2])}></i>

										<i title="Color by parameter" className={"dotted "+(Array.isArray(outlineLayer.paint['line-dasharray']) && outlineLayer.paint['line-dasharray'][0] == .5  ? 'active' : '')} onClick={(e)=>this.handlePaintChange('fill-outline-dasharray', [.5,.5])}></i>
									</Col>
								</div>
								* */}
								 
							</>
						}
					</Row>
				}
				{this.props.layer.data.legend && 
					<Row>
						<Col xs="12">
							<b>Legend</b>
						</Col>
						<div className="mb-3 legend-image">
							<img src={this.props.layer.data.legend} />
						</div>
					</Row>
				}
			</div>	
		);
	}
}

export default LayerStylePanel;